import { Ticker } from '@/common/domain/token/Ticker';

export class Coins {
  constructor(
    public readonly amount: number,
    public readonly ticker: Ticker
  ) {}
}
